import React, { useState, useRef, useEffect } from "react";
import { Button } from "@mui/material";
import FormField from "../../../components/FormField";
import LocationIdFilter from "../../../components/filters/LocationIdFilter";
import { IFavoriteLocationExtension } from "../../../types/IFavoriteOrigins";
import { icons } from "../../../svg";
import { useIsMobile } from "../../../hooks/useIsMobile";

export type SelectedOrigin = { id: string; name: string; products?: string[] };
interface AddOriginColumnProps {
  onAdd: (origin: SelectedOrigin | undefined) => void;
  onCancel?: () => void;
  favoriteOrigins: IFavoriteLocationExtension[];
  context?: string;
  isCompetitor?: boolean;
}

const AddOriginColumn: React.FC<AddOriginColumnProps> = ({
  onAdd,
  onCancel,
  favoriteOrigins,
  context,
  isCompetitor,
}) => {
  const [selectedOrigin, setSelectedOrigin] = useState<
    SelectedOrigin | undefined
  >();
  const isMobile = useIsMobile(768);
  const inputRef = useRef<any>(null);

  // Auto-focus when component mounts in mobile context
  useEffect(() => {
    if (context === "mobileFavoriteOriginPanel" && inputRef.current) {
      // Small delay to make the component and its child components
      // are fully rendered before we try to focus
      const timer = setTimeout(() => {
        inputRef.current?.focus();
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [context]);

  return (
    <div
      className={
        isMobile
          ? "add-origin-column-mobile select-facility-name"
          : "add-origin-column select-facility-name"
      }
    >
      <div
        className="add-origin-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "20px",
        }}
      >
        <span
          className={
            context === "mobileFavoriteOriginPanel"
              ? "select-facility-name-full-screen"
              : ""
          }
        >
          SELECT FACILITY NAME
        </span>
        {onCancel && (
          <Button
            id="add-origin-close-icon"
            onClick={onCancel}
            sx={{
              minWidth: "auto",
              padding: "8px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <img
              data-tooltip-id="add-origin-close-icon"
              src={icons.SimpleCloseIcon}
              alt="Close Icon"
            />
          </Button>
        )}
      </div>
      <div className="add-origin-body">
        <FormField label="">
          <LocationIdFilter
            value={selectedOrigin?.name ?? ""}
            setValue={(value: SelectedOrigin) => {
              setSelectedOrigin(value);
              onAdd(value);
            }}
            isCompetitor={isCompetitor}
            favoriteOrigins={favoriteOrigins}
            config={{
              valueRequired: true,
              autoFocus: context === "mobileFavoriteOriginPanel",
              inputRef,
            }}
          />
        </FormField>
      </div>
    </div>
  );
};

export default AddOriginColumn;
